export default function Loader({ classes = "" }) {
  return null;

  return (
    <div
      className={`spinner-border btn-loader ${
        classes.trim() == "" ? "text-primary" : classes
      }`}
      role="status"
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}
